<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text freemium-plan-dialog__title">
      <h2>{{ 'settings.billing.freemiumPlanDialog.title' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <div class="success-info">
      <div class="checkmark-circle">
        <div class="background"></div>
        <div class="checkmark"></div>
      </div>
      <p>{{ 'settings.billing.freemiumPlanDialog.message' | translate }}</p>
    </div>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">{{ 'cancel' | translate }}</button>
    <button mat-raised-button color="primary" type="button" (click)="goToSubscription()">
      {{ 'settings.billing.freemiumPlanDialog.proceed' | translate }}
    </button>
  </footer>
</div>
